module.exports = __webpack_public_path__ + "img/icon-episode-feed.5ec43cb4.svg";